import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import ResultPage from '@blade-sxp/data-mining/components/result-page.vue';
import { getAllTaskList } from '@blade-sxp/data-mining/apis/index';
let default_1 = class default_1 extends Vue {
    resultVisible;
    loading;
    title;
    feature;
    imgList;
    score;
    task;
    sliderValue = 90;
    isSimilarity = true; // 是否展示相似度
    imgUrl = require('@blade-sxp/data-mining/assets/images/1.png');
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    taskVal = '';
    taskList = [];
    cardList = '';
    disabled = true;
    taskId = '';
    minNum = 30;
    maxNum = 100;
    isChecked = true;
    resultShow(val) {
        this.taskVal = '';
        this.sliderValue = 90;
    }
    async mounted() {
        await this.initData();
    }
    getName(val) {
        if (val) {
            return val;
        }
        return this.$t('name');
    }
    changeSilder(num) {
        this.$emit('silde-num', num, this.task);
    }
    changeInput(num) {
        this.changeSilder(num);
        this.isChecked = !this.isChecked;
        this.disabled = true;
    }
    previous() {
        this.$emit('previous');
    }
    handleClose() {
        this.$emit('close');
    }
    changeTask() {
        this.taskId = this.task;
        this.isChecked = !this.isChecked;
        this.disabled = true;
        this.$emit('task-id', this.task);
    }
    initData() {
        const param = {
            taskTypes: ['REALTIME_CLUSTER'],
        };
        getAllTaskList(param).then((res) => {
            this.taskList = res;
            if (this.task) {
                this.$emit('task-id', this.task);
            }
        });
    }
    changeList(val) {
        if (val) {
            this.disabled = false;
            this.cardList = val;
        }
        else {
            this.disabled = true;
        }
    }
    save() {
        this.$emit('data', this.cardList);
    }
};
__decorate([
    Prop({ default: false })
], default_1.prototype, "resultVisible", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "title", void 0);
__decorate([
    Prop()
], default_1.prototype, "feature", void 0);
__decorate([
    Prop()
], default_1.prototype, "imgList", void 0);
__decorate([
    Prop()
], default_1.prototype, "score", void 0);
__decorate([
    Prop()
], default_1.prototype, "task", void 0);
__decorate([
    Watch('resultVisible')
], default_1.prototype, "resultShow", null);
default_1 = __decorate([
    Component({
        name: 'imageResult',
        components: { BlurPicture, ResultPage },
        i18n: {
            messages: {
                en: {
                    similarity: 'Similarity',
                    save: 'Save',
                    cancel: 'Cancel',
                    Previous: 'Previous',
                    placeholderTask: 'Please select file cluster task',
                    portraits: 'Portraits',
                    name: 'Anonymous',
                },
                zh: {
                    similarity: '相似度',
                    save: '保存',
                    cancel: '取消',
                    Previous: '上一步',
                    placeholderTask: '请选择聚档任务',
                    portraits: '人像库',
                    name: '未知身份',
                },
            },
        },
    })
], default_1);
export default default_1;
